export const safelyParseJSON = (input: unknown): unknown => {
  if (typeof input !== 'string' || input.length === 0 || input === '') {
    return input;
  }

  try {
    const parsedValue = JSON.parse(input);

    if (typeof parsedValue === 'object' || Array.isArray(parsedValue)) {
      return parsedValue;
    }

    if (typeof parsedValue === 'string') {
      return safelyParseJSON(parsedValue);
    }

    return parsedValue;
  } catch (error) {
    return input;
  }
};
